<template>
  <v-dialog max-width="480px" v-model="showDialog" persistent>
    <v-card>
      <v-card-title class="secondary white--text py-3 px-5">
        <span class="text-subtitle-1 font-weight-bold">Delete Trip</span>
        <v-spacer />
        <v-btn icon color="white" small @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-5 pt-4">
        <v-alert
          v-if="trip"
          type="info"
          text
          dense
          border="left"
          class="caption mb-4"
        >
          <strong>{{ trip.trip_id }}</strong> will be deleted. This will free up the assigned driver and vehicle.
        </v-alert>
        <v-textarea
          label="Remarks *"
          outlined
          dense
          rows="3"
          hide-details="auto"
          v-model="remarks"
        />
      </v-card-text>

      <v-divider class="mt-3" />

      <v-card-actions class="px-5 py-3">
        <v-spacer />
        <v-btn
          color="error"
          depressed
          :loading="submitting"
          :disabled="!remarks || !remarks.trim()"
          min-width="120"
          @click="submit"
        >
          Delete Trip
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteTripDialog",
  props: {
    value: { type: Boolean, default: false },
    trip: { type: Object, default: null },
  },
  watch: {
    value(val) {
      if (val) {
        this.remarks = "";
      }
    },
  },
  data() {
    return {
      remarks: "",
      submitting: false,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
    },
    submit() {
      if (!this.trip) return;
      this.submitting = true;
      this.$api.draftTrip
        .deleteDraftTrip(this.trip.id, { remarks: this.remarks.trim() })
        .then(() => {
          this.$bus.$emit("showToastMessage", {
            message: "Trip deleted successfully!",
            color: "success",
          });
          this.$emit("deleted");
          this.closeDialog();
        })
        .catch((err) => {
          this.$bus.$emit("showToastMessage", {
            message:
              (err?.data?.non_field_errors && err.data.non_field_errors[0]) ||
              (err?.data?.remarks && err.data.remarks[0]) ||
              err?.data?.detail ||
              err?.message ||
              "Failed to delete trip.",
            color: "error",
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
